import {Component} from 'react';
import './Archive.scss';
import h from 'react-hyperscript';
import content from 'Assets/data/report-card-overview.json';
import {h4} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
import {toCamelCase, formatDateLong} from 'Src/utils/utils';
import ArchiveEmpty from './ArchiveEmpty';
import ArchiveListItem from './ArchiveListItem';
import ArchiveDropdown from './ArchiveDropdown';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import {ENDPOINTS, getAccessToken} from 'Src/utils/utils';

class ArchiveGuest extends Component {
  constructor(props) {
    super(props);
    const selectedDistrict =
        this.props.districtNames ? this.props.districtNames[0] : null;

    this.pollReportListRetryCount = 0;
    this.pollReportListMaxTries = 7;
    this.pollReportListWait = 5000;

    this.state = {
      reports: null,
      activeSortId: 'semester',
      semesterAscending: true,
      dateGeneratedAscending: false,
      respondentsAscending: false,
      menuAnchorEl: null,
      isLoaded: false,
      districtName: null,
      selectedDistrict: selectedDistrict,
    };
    this.compareBy = this.compareBy.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (!this.state.selectedDistrict) {
      this.setState({isLoaded: true});
      return;
    }

    this.fetchReportList(this.state.selectedDistrict.id);
  }

  fetchReportList(districtId) {
    return fetch(ENDPOINTS.REPORT_LIST, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.props.idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        access_token: getAccessToken(this.props.googleUser),
        district_id: districtId,
      }),
    })
        .then((response) => {
          return response.json();
        })
        .then(
            (result) => {
              if (result.report_cards) {
                if (result.report_cards.length < 1) {
                  this.setReports(null);
                } else {
                  this.setReports(result.report_cards);
                }
              } else {
                console.log('Result needs attention: ', result);
              }
            },
            (error) => {
              console.log('No result', error);
            }
        );
  }

  async pollReportList() {
    const reportMissing = this.reportMissingData(this.state.reportList);
    const tryPoll =
      this.pollReportListRetryCount !== this.pollReportListMaxTries;
    const showDataNotFoundMsg = reportMissing && !tryPoll;

    if (tryPoll) {
      // Retry in X seconds
      await new Promise((resolve) =>
        setTimeout(resolve, this.pollReportListWait)
      );

      await this.fetchReportList(this.state.selectedDistrict.id);

      this.pollReportListRetryCount = ++this.pollReportListRetryCount;
    } else if (showDataNotFoundMsg) {
      this.setState({
        reportLoading: false,
        reportMissingDataNotFound: true,
      });
    }
  }

  reportMissingData(reportList) {
    return (
      reportList &&
      Array.isArray(reportList) &&
      reportList.some((report) => report.missing_data)
    );
  }

  setReports(data) {
    this.setState(
        {
          reports: data,
        },
        () => {
          this.setState({
            isLoaded: true,
          });
          if (this.state.reports && this.state.reports.length > 0) {
            this.props.setLatestReport(this.state.reports[0]);
          }
        }
    );

    if (this.reportMissingData(data)) {
      this.pollReportList();
    } else {
      this.setState({
        reportLoading: false,
      });
    }
    this.props.setLatestSurveyComplete();
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  }

  sortBy(key) {
    const formattedId = toCamelCase(key.replace('_', '-'));
    const _slug = `${formattedId}Ascending`;
    const arrayCopy = [...this.state.reports];
    let colAscending = true;

    if (this.state[_slug]) {
      colAscending = false;
      arrayCopy.reverse();
    }

    arrayCopy.sort(this.compareBy(key));

    this.setState({
      reports: arrayCopy,
      semesterAscending: false,
      dateGeneratedAscending: false,
      respondentsAscending: false,
      [_slug]: colAscending,
      activeSortId: formattedId,
    });
  }

  handleClose() {
    this.setState({
      menuAnchorEl: null,
    });
  }

  setDistrictFilter(district) {
    this.setState({
      ...this.state,
      selectedDistrict: district,
      isLoaded: false,
      districtName: district.name,
    });

    this.fetchReportList(district.id);
  }

  render() {
    if (!this.state.isLoaded) {
      return h(LoadingIndicator, null, null);
    }

    if (this.state.reports) {
      const districtComponent = this.props.districtNames.length > 1 ? h(
          ArchiveDropdown,
          {
            googleUser: this.props.googleUser,
            setDistrictFilter: (district) => this.setDistrictFilter(district),
            districtNames: this.props.districtNames,
            districtName: this.state.districtName,
            csrf: this.props.csrf,
            idToken: this.props.idToken,
            districtId: this.props.districtId,
          },
      ) : h('h4', this.state.selectedDistrict.name);
      return h(
          'div',
          {
            className: 'report-overview__archive',
          },
          [
            h('div',
                {
                  id: 'archive__breadcrumbs-menu',
                  className: 'flex--wrap',
                }, [

                  h(
                      h4,
                      {
                        key: 'report-overview__header',
                        className: 'report-overview__header',
                      },
                      `${content.archive.title}`
                  ),

                  h(
                      'span',
                      {
                        className: `material-icons text--grey
                              padding-left--micro`,
                      },
                      'keyboard_arrow_right'
                  ),
                  districtComponent,
                ]),


            h(
                BasicCard,
                {
                  key: 'report-overview__card',
                  type: 'basic',
                },
                h('table', null, [
                  h(
                      'thead',
                      {
                        key: 'report-overview__thead',
                      },
                      [
                        h(
                            'tr',
                            {
                              key: 'report-overview__thead-row',
                            },
                            [
                              content.archive.headers.map((item, i) => {
                                const slug = toCamelCase(
                                    item.id.replace('_', '-')
                                );
                                const _slug = `${slug}Ascending`;
                                const classes = `
                                  material-icons margin-right--micro${
                                    this.state.activeSortId === slug ?
                                      ' visible' :
                                      ' invisible'}`;
                                return h(
                                    'th',
                                    {
                                      key: item.id,
                                      className: 'text--grey text--bold',
                                      onClick: () => {
                                        this.sortBy(item.id);
                                      },
                                    },
                                    [
                                      h('span', {
                                        className: classes,
                                      }, this.state[_slug] ?
                                        'arrow_upward' :
                                        'arrow_downward'
                                      ),
                                      item.title,
                                    ]
                                );
                              }),
                              h('th', null, null),
                            ]
                        ),
                      ]
                  ),

                  h('tbody', null, [
                    this.state.reports.map((item, i) => {
                      const slug = item.report_card_name_slug;
                      const formattedDate = formatDateLong(item.created_date);
                      return h(
                          ArchiveListItem,
                          {
                            key: slug + '_' + item.district_id,
                            slug: slug,
                            districtId: item.district_id,
                            districtName: item.district_name,
                            userStatus: this.props.userStatus,
                            formattedDate: formattedDate,
                            reportId: item.district_report_card_id,
                            title: item.report_card_name,
                            missing_data: item.missing_data,
                            respondents: item.survey_respondents,
                            i: i,
                          },
                          null
                      );
                    }),
                  ]),
                ])
            ),
          ]
      );
    } else {
      return h(
          ArchiveEmpty,
          {
            districtName: this.props.districtName,
            headers: content.archive.headers,
            title: content.archive.title,
            userStatus: this.props.userStatus,
          },
          null
      );
    }
  }
}

export default ArchiveGuest;
